
import React from 'react';

import Plasticehandle from './Plasticehandle';
import Petbottlehandel from './Petbottlehandel';
import Bottlehandlestabl from './Bottlehandlestabl';


const Plasticbottlehand = () => {
    return (
        <div>
             <Plasticehandle />
            <Petbottlehandel />
            <Bottlehandlestabl />
        </div>
    );
};

export default Plasticbottlehand;
